export default {
  title: 'Quality report',
};
